import { render, staticRenderFns } from "./Azure.vue?vue&type=template&id=33beba75"
import script from "./Azure.vue?vue&type=script&lang=js"
export * from "./Azure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports